module.exports = __webpack_public_path__ + "static/Abinash-Mohapatra-8b2d9c0f28ed67d29620ece8278a24f8.png";